export default {"src":"/_next/static/media/football_substitution_team_1.62248500.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};